<template>
  <!---全体を囲む--->
  <div class="content-wrapper">
    <TemplateStampBook v-if="isReadyToDraw" />

    <!-- 描画ローディング -->
    <DialogInitialLoading v-else />
  </div>
</template>

<script>
import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import TemplateStampBook from "@/views/Templates/MyTickets/TemplateStampBook";

import API from "@/API";

import mfittService from "@/services/MFITT";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "StampBook",
  components: {
    TemplateStampBook: TemplateStampBook,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const isReadyToDraw = ref(false);

    onMounted(async () => {
      try {
        await Promise.all([
          API.getMyticketDetail(route.params.book_group_id),
          API.getMyCoupons(),
        ]);

        isReadyToDraw.value = true;
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "StampBook onMounted()",
          JSON.stringify(err)
        );
        console.log("error in StampBook", err);
      }
    });

    return {
      isReadyToDraw,
    };
  },
};
</script>
